import routeConstants from '../../constants/routeConstants';

export function isDeliveryPage(pathname, editBasketModalBaseRoutePath, leaveCheckoutModalBaseRoutePath) {
  if (
    pathname.indexOf(routeConstants.DELIVERY) === 0 ||
    pathname.indexOf(routeConstants.DELIVERY_CHOICE) === 0 ||
    pathname.indexOf(routeConstants.CLICK_AND_COLLECT) === 0 ||
    (
      pathname.indexOf(routeConstants.EDIT_BASKET) === 0 &&
      (
        editBasketModalBaseRoutePath.indexOf(routeConstants.DELIVERY) !== -1 ||
        editBasketModalBaseRoutePath.indexOf(routeConstants.CLICK_AND_COLLECT) !== -1
      )
    ) ||
    (
      pathname.indexOf(routeConstants.LEAVE_CHECKOUT) === 0 &&
      (
        leaveCheckoutModalBaseRoutePath.indexOf(routeConstants.DELIVERY) !== -1 ||
        leaveCheckoutModalBaseRoutePath.indexOf(routeConstants.CLICK_AND_COLLECT) !== -1
      )
    )
  ) {
    return true;
  }

  return false;
}

export function isPaymentPage(pathname, editBasketModalBaseRoutePath, leaveCheckoutModalBaseRoutePath) {
  if (
    pathname.indexOf(routeConstants.PAYMENT) === 0 ||
    pathname.indexOf(routeConstants.PAYMENT_POS_CREDIT_CALLBACK) === 0 ||
    (
      pathname.indexOf(routeConstants.EDIT_BASKET) === 0 &&
      editBasketModalBaseRoutePath.indexOf(routeConstants.PAYMENT) !== -1
    ) ||
    (
      pathname.indexOf(routeConstants.LEAVE_CHECKOUT) === 0 &&
      leaveCheckoutModalBaseRoutePath.indexOf(routeConstants.PAYMENT) !== -1
    )
  ) {
    return true;
  }

  return false;
}
